import { MapObjectProperties } from "@iventis/map-types";
import GeoJSON from "geojson";
import { Content } from "@iventis/translations/content/typed-content";
import { Body2 } from "@iventis/styles/src/components/texts";
import React, { FunctionComponent } from "react";
import { styled } from "@iventis/styles";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { getLengthInAppropriateUnits } from "@iventis/map-engine/src/utilities/geojson-helpers";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { contentCss } from "./analysis.helpers";

export const AnalysisDistanceComponent: FunctionComponent<{ feature: GeoJSON.Feature<GeoJSON.LineString, MapObjectProperties>; unitOfMeasurement: UnitOfMeasurement }> = ({
    feature,
    unitOfMeasurement,
}) => {
    const translate = useIventisTranslate();
    return (
        <StyledContent>
            <Body2 className="bold">{translate(Content.map2.analysis.distance_content.title)}</Body2>
            <Body2 data-testid="distance-analysis-result">{getLengthInAppropriateUnits(feature, unitOfMeasurement)}</Body2>
        </StyledContent>
    );
};

const StyledContent = styled.div`
    ${contentCss}
`;
